import styled, { css } from "styled-components";

export interface StyledLiProps {
  disabled?: boolean;
  selected?: boolean;
  isToday?: boolean;
  isBetween?: boolean;
  decoratorDirection?: "left" | "right" | "all";
}

const semanticTokens = {
  size: "100%",
};

export const Li = styled.li<StyledLiProps>`
  width: ${semanticTokens.size};
  height: ${semanticTokens.size};
  position: relative;

  list-style: none;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  > div {
    padding: 0.6rem;
  }

  /* status: default */
  ${({ theme }) => css`
    ${theme.typography.body2.regular}

    color: ${theme.color.text.default};
  `}

  ${({ theme, isBetween, decoratorDirection }) => css`
    background-color: ${isBetween
      ? theme.color.background.secondary
      : "inherit"};

    border-radius: ${decoratorDirection === "right"
      ? "50% 0% 0% 50%"
      : decoratorDirection === "left"
        ? "0% 50% 50% 0%"
        : decoratorDirection === "all"
          ? "100%"
          : "0%"};
  `}

  /* status: disabled */
  ${({ theme, disabled }) =>
    disabled &&
    css`
      color: ${theme.color.text.disabled};
    `}

  /* status: today */
  ${({ theme, isToday }) =>
    isToday &&
    css`
      color: ${theme.color.brick[400]};
    `}

  ${({ theme, selected }) =>
    selected
      ? css`
          /* status: selected */

          > div {
            background-color: ${theme.color.button.primary.enabled};
            color: ${theme.color.text.white};
            border-radius: 999rem;
            width: 100%;
            height: 100%;
          }
        `
      : css`
          /* status: hover */
          &:hover {
            background: none;
            color: ${theme.color.text.secondary};
          }
        `}
`;
